import React from 'react';
import { formatMoney } from '../../lib/reportHelpers';

const Card = ({ title, value }) => (
  <div className="rounded-xl border bg-white p-4 shadow-sm">
    <div className="text-sm text-slate-500">{title}</div>
    <div className="mt-2 text-xl font-semibold text-slate-900">{value}</div>
  </div>
);

const ReportSummaryCards = ({ items = [] }) => {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {items.map((item, idx) => (
        <Card
          key={idx}
          title={item.title}
          value={item.money ? formatMoney(item.value) : item.value}
        />
      ))}
    </div>
  );
};

export default ReportSummaryCards;